import { render, staticRenderFns } from "./RsaStoricoRicoveriComponent.vue?vue&type=template&id=4621b5f9"
import script from "./RsaStoricoRicoveriComponent.vue?vue&type=script&lang=js"
export * from "./RsaStoricoRicoveriComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports